import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <span className="text-xs font-semibold text-primary-500 uppercase tracking-wider">📰 NEWS</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-2">最新资讯</h2>
          <p className="text-sm text-foreground-500 mt-1">漫画圈最新动态、番剧定档、活动资讯一网打尽</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cardsData.slice(0, 3).map((item, idx) => (
            <a
              key={idx}
              href="#"
              className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer no-underline block hover:bg-background-200/70 transition-colors duration-200"
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 text-[10px] font-medium bg-primary-100 text-primary-700 rounded-full">{item.tag}</span>
                  <span className="text-xs text-foreground-400">{item.date}</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors mb-2 line-clamp-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
          {cardsData.slice(3).map((item, idx) => (
            <a
              key={idx + 3}
              href="#"
              className="group flex flex-col sm:flex-row gap-4 p-5 bg-background-100 rounded-2xl cursor-pointer no-underline hover:bg-background-200/70 transition-colors duration-200"
            >
              <div className="w-full sm:w-48 flex-shrink-0 aspect-[16/10] sm:aspect-[4/3] rounded-xl overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 text-[10px] font-medium bg-secondary-100 text-secondary-700 rounded-full">{item.tag}</span>
                  <span className="text-xs text-foreground-400">{item.date}</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}